import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StatusEventGroupPageComponent} from '@components/pages/page-components/status-event-group-page/status-event-group-page/status-event-group-page.component';
import {StatusEventGroupPageActionsComponent} from '@components/pages/page-components/status-event-group-page/status-event-group-page-actions/status-event-group-page-actions.component';
import {TranslateModule} from '@ngx-translate/core';
import {NgbCollapseModule, NgbDropdownModule, NgbNavModule} from '@ng-bootstrap/ng-bootstrap';
import {NgSelectModule} from '@ng-select/ng-select';
import {SharedModule} from '@shared/shared.module';
import {StatusEventGroupRowComponent} from '@components/pages/page-components/status-event-group-page/status-event-group-row/status-event-group-row.component';
import {MachineStatusEventsTableComponent} from './status-event-group-row/machine-status-events-table/machine-status-events-table.component';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    StatusEventGroupPageComponent,
    StatusEventGroupPageActionsComponent,
    StatusEventGroupRowComponent,
    MachineStatusEventsTableComponent
  ],
  exports: [
    StatusEventGroupPageActionsComponent,
    StatusEventGroupPageComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    NgbDropdownModule,
    NgSelectModule,
    NgbNavModule,
    SharedModule,
    NgbCollapseModule,
    ReactiveFormsModule
  ]
})
export class StatusEventGroupPageModule {
}
